import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css'; // Import Swiper styles
import SwiperCore, { Autoplay } from 'swiper'; // Import Swiper and Autoplay

// Install the Autoplay module
SwiperCore.use([Autoplay]);

const TestimonialSlider = () => {
  return (
    <section className='testimonials border-bottom'>
      <div className="container testimonial-slider">
        <div className='heading-sec w-100 g-5 text-center mb-4'>
          <div className='strip-heading'>Testimonials</div>
          <h2 className='h3-heading text-dark'>What client says!</h2>
        </div>
        <div className='test-monial-card m-auto text-center'>
          <Swiper 
            spaceBetween={30}
            slidesPerView={1}
            autoplay={{
              delay: 3000, // Delay in milliseconds
              disableOnInteraction: false, // Continue autoplay even after interaction
            }}
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial bg-light p-lg-5 py-5 px-4 rounded-4">
                  <p className='px-lg-5 mb-3'>"{testimonial.text}"</p>
                  <div className='h6-heading'>{testimonial.name}</div>
                  <div className='fs-6'>{testimonial.position}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

const testimonials = [
  {
    name: "Sarah L.",
    text: "Working with [Company Name] has been a game-changer for our business. Their expertise in software development helped us launch our product ahead of schedule. Highly recommended!",
    position: "Marketing Manager at Tech Innovations",
  },
  {
    name: "John D.",
    text: "The team at [Company Name] truly understands our needs. They delivered a seamless integration that transformed our operations. Professional, responsive, and results-driven!",
    position: "CEO of Green Solutions",
  },
  {
    name: "Emily R.",
    text: "Thanks to [Company Name], our IT infrastructure is now more reliable than ever. Their support team is always available and incredibly helpful. Five stars!",
    position: "Operations Director at Smart Home Corp",
  },
  {
    name: "Mark T.",
    text: "We partnered with [Company Name] for our cybersecurity needs, and it was the best decision we made. Their proactive approach keeps our data safe and secure.",
    position: "Founder of NextGen Startups",
  },
  {
    name: "Lisa P.",
    text: "The developers at [Company Name] are top-notch. They took our vague ideas and turned them into a fully functional app. We couldn’t be happier!",
    position: "Product Manager at Cloud Services Inc.",
  },
];

export default TestimonialSlider;
